import React, { FC } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row } from "antd";
import { IAssessmentViewProps } from "./types";
import DynamicTable from "@Components/shared/DynamicTable";
import EditableCell, { mergedColumns } from "@Components/shared/EditableCell";
import { ITaskDetails } from "@Models/ITaskDetails";
import { INITIAL_TASK_VALUES } from "./assessmentConstants";

interface ICreateTaskFormProps extends IAssessmentViewProps<ITaskDetails> {
  taskRows: {
    addRow: () => void;
    rows: ITaskDetails[];
  };
}

const CreateTasksForm: FC<ICreateTaskFormProps> = ({ columnData, isDisabled, isLoading, taskRows }) => {
  const { addRow, rows } = taskRows;
  const columns = mergedColumns(columnData, "tasks", INITIAL_TASK_VALUES);

  return (
    <Row gutter={[16, 8]} justify="center">
      <Col span={24}>
        <DynamicTable
          components={
            isDisabled
              ? {}
              : {
                  body: {
                    cell: EditableCell,
                  },
                }
          }
          columnData={columns}
          // giving each row a unique index in the absence of taskId
          dataSource={rows.map((value, key) => ({ ...value, key }))}
          isLoading={isLoading}
        />
      </Col>

      {!isDisabled && (
        <Col span={2}>
          <Form.Item>
            <Button type="dashed" onClick={addRow} block icon={<PlusOutlined />} />
          </Form.Item>
        </Col>
      )}
    </Row>
  );
};

export default CreateTasksForm;

